import { RATE, START_DATE_OFFSET_MONTHS_FROM_TODAY } from './Filters.constants'
import type { FilterValues } from './Filters.types'

export function getInitialFiltersValues(): FilterValues {
  const todayDate = new Date()
  const defaultStartDate = new Date().setMonth(
    todayDate.getMonth() - START_DATE_OFFSET_MONTHS_FROM_TODAY,
  )

  return {
    orderId: '',
    minRate: RATE.MIN,
    maxRate: RATE.MAX,
    market: '',
    endDate: '',
    // startDate eg: 2024-01-01
    startDate: new Date(defaultStartDate).toISOString().split('T')[0],
    categoryId: '',
  }
}
